import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003604, P0003604Data } from './P0003604';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P0004704 extends IProduct {
  override deviceTableIndex: number = 23;

  override modelIdentifier?: string = 'P00047-04';

  override dataIdentifier?: string = 'P0004704';

  override manufacturerName?: string = 'ACWA';

  data: P0003604Data = new P0003604Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0004704/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0004704/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0004704/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0004704;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0004704?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0004704.tuto.installation.help.title',
      helpSlides: [
        'P0004704.tuto.installation.help.1',
        'P0004704.tuto.installation.help.2',
        'P0004704.tuto.installation.help.3',
        'P0004704.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004704/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004704/installation-1_dark.png',
          },
          text: 'P0004704.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004704/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0004704/installation-2_dark.png',
          },
          text: 'P0004704.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0004704/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0004704/installation-1_dark.png',
          },
          text: 'P0004704.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0004704/update-2.png',
            dark: '/assets/ecosystem/images/products/P0004704/update-2_dark.png',
          },
          text: 'P0004704.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P0003604().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P0003604().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P0003604().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P0003604().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 18;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).blIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
